import { Context } from '@/context/appContext';
import { logEvent } from '@/helpers/eventLogger';
import { useContext, useEffect } from 'react';
import { StripePaymentModal } from './Stripe/StripePaymentModal';

/**
 * The paywall's mount point. Stripe is the only payment provider: the Paddle and Dodo
 * checkouts and the `getPaymentProvider` lookup that switched between them were removed on
 * 2026-08-22. The backend still knows about the other providers — only the UI is Stripe-only.
 */
function PaymentModalWrapper() {
  const {
    state: { needPayment },
  } = useContext(Context);

  useEffect(() => {
    needPayment && logEvent({ logType: 'EVENT', eventType: 'SUBSCRIPTION_MODAL_OPENED' });
  }, [needPayment]);

  return needPayment ? <StripePaymentModal /> : null;
}

export { PaymentModalWrapper as PaymentModal };
